<template>
    <div class="container px-4 mx-auto mt-5 max-w-7xl" v-if="products || responce">
        <div class="product-grid grid grid-cols-2 gap-5 md:grid-cols-4" v-if="products.length != 0">
            <article class="product-tile" v-for="product in products" :key="product.id">
                <router-link class="product-media"
                    :to="{ name: 'DefaultProduct', params: { id: product.id, slug: sanitizeTitle(product.name ? product.name : product.vendor.name) } }">
                    <img v-if="product" v-bind:src="product.photo" class="product-photo h-40 md:h-52 w-44 md:w-64" :alt="product.name">
                </router-link>
                <div class="product-details">
                <div class="flex justify-between mt-2">
                    <p class="product-name text-xs font-light">{{ truncate(product.name, 100) }}</p>
                    <span v-show="isLoggedIn">
                        <button @click="addToFavourite(product)">
                            <img src="/img/icons/favourite-border.svg" class="w-6 h-6" alt="">
                        </button>
                    </span>

                </div>
                <div v-if="product.discount_price > 0">
                    <p class="product-price font-medium">{{ currency }}{{product.discount_price.toFixed(2)}} <span class="text-xs ">{{ currency }}<span class="line-through">{{product.price.toFixed(2)}}</span></span></p>
                </div>
                <div v-else>
                    <p class="product-price">{{ currency }}{{ product.price.toFixed(2) }}</p>
                </div>
                <router-link
                    :to="{ name: 'DefaultVendor', params: { id: product.vendor.id, slug: sanitizeTitle(product.vendor.name) } }"
                    class="text-xs text-gray-500 underline ">{{ product.vendor.name }}</router-link>
                </div>
            </article>
        </div>
        <div v-if="responce.current_page != responce.last_page" class="flex items-center justify-center mt-5">
            <button @click="$emit('load-more')" class="w-40 p-2 text-sm text-center text-gray-700 bg-gray-300 rounded">{{ $t('pages.seemore') }}</button>
        </div>
        <!-- <p v-else class="text-center text-gray-500">No products</p> -->
        <!-- <p>here = {{ responce.current_page }}</p> -->
        <div v-if="responce.current_page == responce.last_page && responce.last_page > 1" class="flex items-center justify-center mt-5">

            <button @click="$emit('load-less')" class="w-40 p-2 text-sm text-center text-gray-700 bg-gray-300 rounded">{{ $t('pages.seeless') }}</button>
        </div>


    </div>
</template>
<script>
import axios from "axios";
import { notify } from "@kyvg/vue3-notification";
export default {
    name: 'ProductsList',

    props: {
        products: Object,
        responce: Object
    },

    data() {
        return {
            currency: null,
            pageNo: 1,
            showMore: true,
            dontShow: false,
            base_url: this.$store.state.baseUrl,
            isLoggedIn: false,
            AuthStr: "Bearer " + localStorage.getItem("authToken"),
        }
    },

    mounted() {
        if (localStorage.getItem("authToken")) {
            this.isLoggedIn = true;
            this.user = JSON.parse(localStorage.getItem("user"));
        }

        this.$store.dispatch('fetchSettings').then(() => {
            this.settings = this.$store.state.settings;
            this.currency = this.settings.strings.currency
        })
    },


    methods: {

        addToFavourite(product) {

            axios.post(this.base_url + 'api/favourites/',
                {
                    product_id: product.id,
                    is_favourite: true
                }, {
                'headers': { 'Authorization': this.AuthStr }
            })
                .then((response) => {
                    notify({
                        type: "success",
                        title: "Favourited",
                        text: response.data.message,
                    })
                })
                .catch(error => console.log(error))

        },


        showLess(responce) {
            console.log(responce)
            // console.log('products')
            if (responce) {
                if (responce.to == null) {
                    this.dontShow = true;
                    console.log(this.dontShow)
                    this.showMore = false;
                    console.log(responce)
                }
            }
            // if(products == [] ||  Object.keys(products).length === 0){
            //     this.dontShow = true;
            //     this.showMore = false;
            //     console.log(products)
            // } else {
            //     this.showMore = true;
            //     this.dontShow = false
            //     // console.log('here')
            // }
        },


        truncate(str, n) {
            return (str.length > n) ? str.substr(0, n - 1) + '...' : str;
        },
        sanitizeTitle(title) {
            var slug = "";
            // Change to lower case
            var titleLower = title.toLowerCase();
            // Letter "e"
            slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
            // Letter "a"
            slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
            // Letter "o"
            slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
            // Letter "u"
            slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
            // Letter "d"
            slug = slug.replace(/đ/gi, 'd');
            // Trim the last whitespace
            slug = slug.replace(/\s*$/g, '');
            // Change whitespace to "-"
            slug = slug.replace(/\s+/g, '-');

            return slug;
        },
    }
}
</script>

<style scoped>
.grid {
    gap: 0.75rem;
}

.product-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

@media (min-width: 768px) {
    .product-grid {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }
}

@media (min-width: 1200px) {
    .product-grid {
        grid-template-columns: repeat(6, minmax(0, 1fr));
    }
}

.product-tile {
    min-width: 0;
    overflow: hidden;
    border: 1px solid var(--color-line);
    border-radius: 0.85rem;
    background: var(--color-surface);
    transition: transform 180ms ease, box-shadow 180ms ease;
}

.product-tile:hover {
    transform: translateY(-3px);
    box-shadow: 0 14px 32px rgba(32, 52, 43, 0.1);
}

.product-media {
    display: block;
    overflow: hidden;
    background: #eef3ef;
}

.product-photo {
    display: block;
    width: 100%;
    height: 7.25rem;
    object-fit: cover;
    transition: transform 220ms ease;
}

.product-tile:hover .product-photo {
    transform: scale(1.035);
}

.product-details {
    padding: 0.55rem 0.6rem 0.65rem;
}

.product-name {
    min-height: 1.9rem;
    color: var(--color-ink);
    font-size: 0.76rem;
    font-weight: 700;
    line-height: 1.5;
}

.product-price {
    margin-top: 0.4rem;
    color: var(--color-green-dark);
    font-size: 0.86rem;
    font-weight: 800;
}

.product-details > a {
    display: inline-block;
    margin-top: 0.4rem;
    color: var(--color-muted);
    font-size: 0.7rem;
    text-decoration: none;
}

@media (min-width: 768px) {
    .product-photo {
        height: 7.25rem;
    }
}

@media (max-width: 767px) {
    .product-photo {
        height: 6.5rem;
    }
}
</style>